<!-- 首页右边框-主内容 -->
<template>
	<div>
		<el-row :gutter="24">
			<el-col :span="6">
				<div style="background: #fff;border-radius: 6px;width: 100%;height: 80px;justify-content: center;"
					class="d-flex align-items-center">
					<div style="width: 72%;margin-left: 6%;">
						<div style="font-size: 13px;margin-bottom: 4px;">发货单<span style="margin-left: 5px;color: #5f8800;">(处理中)</span></div>
						<div style="font-size: 16px;font-weight: 800;">{{sj_num_fhd}}</div>
					</div>
					<div style="width: 22%;">
						<img src="@/image/index1.png" style="width: 36px;height: 36px;">
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div style="background: #fff;border-radius: 6px;width: 100%;height: 80px;justify-content: center;"
					class="d-flex align-items-center">
					<div style="width: 72%;margin-left: 6%;">
						<div style="font-size: 13px;margin-bottom: 4px;">司机<span style="margin-left: 5px;color: #a6a6a6;">(休息中)</span></div>
						<div style="font-size: 16px;font-weight: 800;">{{sj_num_xx}}</div>
					</div>
					<div style="width: 22%;">
						<img src="@/image/index4.png" style="width: 36px;height: 36px;">
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div style="background: #fff;border-radius: 6px;width: 100%;height: 80px;justify-content: center;"
					class="d-flex align-items-center">
					<div style="width: 72%;margin-left: 6%;">
						<div style="font-size: 13px;margin-bottom: 4px;">司机<span style="margin-left: 5px;color: #ff7700;">(上货中)</span></div>
						<div style="font-size: 16px;font-weight: 800;">{{sj_num_sh}}</div>
					</div>
					<div style="width: 22%;">
						<img src="@/image/index3.png" style="width: 36px;height: 36px;">
					</div>
				</div>
			</el-col>
			<el-col :span="6">
				<div style="background: #fff;border-radius: 6px;width: 100%;height: 80px;justify-content: center;"
					class="d-flex align-items-center">
					<div style="width: 72%;margin-left: 6%;">
						<div style="font-size: 13px;margin-bottom: 4px;">司机总数<span style="margin-left: 5px;color: #40a6ff;">(上班中)</span></div>
						<div style="font-size: 16px;font-weight: 800;">{{sj_num_fhd}}</div>
					</div>
					<div style="width: 22%;">
						<img src="@/image/index2.png" style="width: 36px;height: 36px;">
					</div>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="24" style="margin-top: 10px;">
			<el-col :span="16">
				<div class="d-flex">
					<div style="background: #fff;border-radius: 6px;width: 100%;height: 220px;">
						<div ref="myCharpath1" style="width: 100%; height: 200px;"></div>
					</div>
				</div>
				<div class="d-flex" style="margin-top: 10px;">
					<div style="background: #fff;border-radius: 6px;width: 100%;height: 220px;">
						<div ref="myCharpath4" style="width: 100%; height: 220px;"></div>
					</div>
				</div>
			</el-col>
			<el-col :span="8">
				<div class="d-flex">
					<div style="background: #fff;border-radius: 6px;width: 100%;height: 450px;">
						<div class="d-flex align-items-center" style="width: 100%;height: 40px;">
							<div style="font-size: 16px;margin-left: 10px;font-weight: 800;">班车司机状态表</div>
							<div style="margin-left: 10px;width: 10px;height: 8px;background: #626262;"></div>
							<div style="margin-left: 10px;font-size: 10px;">休息中</div>
							<div style="margin-left: 10px;width: 10px;height: 8px;background: #e17800;"></div>
							<div style="margin-left: 10px;font-size: 10px;">上货中</div>
							<div style="margin-left: 10px;width: 10px;height: 8px;background: #0011ff;"></div>
							<div style="margin-left: 10px;font-size: 10px;">送货中</div>
						</div>
						<div class="d-flex align-items-center" style="width: 100%;height: 20px;">
							<div style="font-size: 13px;margin-left: 10px;font-weight: 800;color: #40a6ff;">南海库</div>
						</div>
						<div class="exam-list">
							<div class="exam-item" v-for="(item,index) in sj_lista" :class="item.gzzt == 0 ? 'gzzt_0' : item.gzzt == 1 ? 'gzzt_1' : 'gzzt_2'">
								<div style="font-size: 12px;color: #fff;">{{item.name}}</div>
							</div>
						</div>
						<div class="d-flex align-items-center" style="width: 100%;height: 20px;margin-top: 10px;">
							<div style="font-size: 13px;margin-left: 10px;font-weight: 800;color: #40a6ff;">石井库</div>
						</div>
						<div class="exam-list">
							<div class="exam-item" v-for="(item,index) in sj_listb" :class="item.gzzt == 0 ? 'gzzt_0' : item.gzzt == 1 ? 'gzzt_1' : 'gzzt_2'">
								<div style="font-size: 12px;color: #fff;">{{item.name}}</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'; // 引入 全局 公共数据
	import 'echarts/map/js/china.js';
	import moment from 'moment';
	import * as vueEcharts from "echarts";
	let echarts = require('echarts');
	export default {
		data() {
			return {
				mon_day:[],
				mon_days:[],
				myChart: null,
				moment,
				sj_list: [],
				sj_lista: [],
				sj_listb: [],
				ck_list: [],
				sj_num_sb: 0,
				sj_num_xx: 0,
				sj_num_sh: 0,
				sj_num_fhd: 0,
				sj_Chart: [],
				sj_Chart_name: [],
				lxa:[],
				lxb:[],
				lxc:[]
			};
		},

		computed: {
			// 引入store-modules的user模块里面的user(存储用户相关的数据)
			...mapState({
				user: state => state.user.user,
				navBar: state => state.menu.navBar
			})
		},
		// 生命周期
		created() {

		},
		// dom渲染完毕 mounted生命周期
		mounted() {

			this.drawLine();
			this.changeRecent()

			this.axios.post('/admin/sj_mblist', {year:this.mon_days}, {
					token: true
				})
				.then(res => {
					this.sj_num_sb = res.data.data.num_sb
					this.sj_num_xx = res.data.data.num_xx
					this.sj_num_sh = res.data.data.num_sh
					this.sj_num_fhd = res.data.data.num_fhd
					this.sj_list = res.data.data.list
					this.sj_lista = res.data.data.lista
					this.sj_listb = res.data.data.listb
					this.lxa = res.data.data.lxa
					this.lxb = res.data.data.lxb
					this.lxc = res.data.data.lxc
					this.axios.post('/admin/sy_cklist', {}, {
							token: true
						})
						.then(res => {
							this.ck_list = res.data.data

							for (let i of this.ck_list) {
								let num = 0
								for (let ck of this.sj_list) {
									if (i.id == ck.ck_id) {
										num += 1
									}
								}
								this.sj_Chart.push(num)
								this.sj_Chart_name.push(i.name)
							}



						});



				});
		},
		// 画统计图方法
		methods: {
			// 近15日
			changeRecent() {
				for (let i = 0; i < 30; i++) {
					this.mon_days.push(moment(new Date().getTime() - i * 1000 * 24 * 60 * 60).format('yy-MM-DD'))
					this.mon_day.push(moment(new Date().getTime() - i * 1000 * 24 * 60 * 60).format('MM-DD'))
				}
			},
			drawLine() {
				// 初始化echarts实例


				let myCharpath1 = echarts.init(this.$refs.myCharpath1);
				let myCharpath4 = echarts.init(this.$refs.myCharpath4);

				var that = this;
				setTimeout(function() {

					myCharpath1.setOption({
						title: {
							text: '各库司机分布'
						},
						grid: {
							left: '3%',
							right: '7%',
							top: '20%',
							bottom:'2%',
							containLabel: true
						},
						tooltip: {
							trigger: 'axis',
							axisPointer: {
								type: 'shadow'
							}
						},
						xAxis: {
							type: 'value',
						},
						yAxis: {
							type: 'category',
							data: that.sj_Chart_name
						},
						series: [{
							type: 'bar',
							data: that.sj_Chart
						}]
					}),
					myCharpath4.setOption({
						title: {
							text: '近30天班车线路走势图'
						},
						tooltip: {
							trigger: 'axis'
						},
						legend: {
							data: ['海珠南', '一德路','其他']
						},
						grid: {
							left: '3%',
							right: '2%',
							top: '20%',
							bottom:'2%',
							containLabel: true
						},
						xAxis: {
							type: 'category',
							data: that.mon_day
						},
						yAxis: {
							type: 'value'
						},
						series: [
							{
								name: '海珠南',
								type: 'line',
								data: that.lxa
							},
							{
								name: '一德路',
								type: 'line',
								data: that.lxb
							},
							{
								name: '其他',
								type: 'line',
								data: that.lxb
							},
							
						]
					})
					
				}, 1000);
			},
		},
		beforeUnmount() {
			console.log('beforeUnmount')
			if (!myChart) {
				return
			}
			// window.removeEventListener('resize', this.__resizeHandler)
			myChart.dispose()
			let myChart = null
		},
	};
</script>

<style>

	.exam-list {
		margin-left: 10px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
	}
	.exam-item {
		display: flex;
		justify-content: center;
		align-items: center;
		flex: 1;
		height: 30px;
		box-sizing: border-box;
		width: calc((100% - 10px) / 5);
		min-width: calc((100% - 10px) / 5);
		max-width: calc((100% - 10px) / 5);
		
	}
	&:nth-child(4n + 4) {
	  	margin-right: 0;
	}
	.gzzt_0{
		background: #626262;
	}
	.gzzt_1{
		background: #e17800;
	}
	.gzzt_2{
		background: #0011ff;
	}
</style>